export default "__VITE_ASSET__br30TZqn__"